export default __webpack_public_path__ + "static/media/telefon ekran.e9d317b0.png";